import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'

const service =  {
    name: 'PipelineBasic',
    label: 'Pipeline Basic',
    permissionId: 'pipelinebasic',
    iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  showDissolveClock: false,
  data: [
  ],
  layers: [
    // {
    //   name: 'Sentinel1Arctic',
    //   label: 'Sentinel 1 (75 m)',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'Sentinel1Arctic',
    //   secondary: true
    // },
    // {
    //   name: 'Sentinel2Pipeline',
    //   label: 'Imagery',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'Sentinel2Pipeline',
    //   secondary: true,
    //   hidden: true
    // },
    {
      name: 'PipelineBasic',
      label: 'Analysis',
      opacity: 'raster-opacity',
      datetimeId: 'PipelineGreen',
      open: true,
      legend: {
        type: 'categorical',
        data: pipelineGreenLegend
      }
    },
    // {
    //   name: 'PipelineGreen',
    //   label: 'Analysis',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreen',
    //   hidden: true,
    //   legend: {
    //     type: 'categorical',
    //     data: pipelineGreenLegend
    //   }
    // },
    {
      name: 'EnbridgePipeline',
      label: 'Enbridge Pipeline',
      opacity: 'vector-opacity',
      hidden: true,
    },
    ],
  locations: [
    {
      name: 'MackinawCity',
      label: 'Mackinaw City',
      latitude: 45.8461,
      longitude: -84.7701,
      maxBounds: [[-150, -85], [80, 85]],
      zoom: [13]
    }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/PipelineBasic.js